import { autorun, toJS } from 'mobx';
import { useEffect, useState } from 'react';

import { Stores, useStores } from '@src/store';

/**
 * 自定义Hook：将MobX的响应式数据转换为React的非响应式状态
 * 为什么需要这个函数？简而言之就是避免在组件里混杂着react和mobx的代码，导致数据流混乱。详细看：https://iwiki.woa.com/p/4014074233#4.3.-%E5%B1%80%E9%99%90%26%E5%9D%91%E7%82%B9
 * @param selector 选择器函数，从stores中提取所需数据
 * @returns 转换后的非响应式数据
 */
function useMobxSelector<T>(selector: (stores: Stores) => T): T {
  // 获取stores实例
  const stores = useStores();
  // 初始化状态，使用toJS将响应式数据转为普通JS对象
  const [data, setData] = useState<T>(() => toJS(selector(stores)));

  useEffect(() => {
    // 使用autorun监听selector依赖的变化
    const dispose = autorun(() => {
      // 当依赖变化时，更新状态
      setData(toJS(selector(stores)));
    });
    // 组件卸载时清理autorun
    return () => dispose();
  }, []);

  return data;
}

export default useMobxSelector;